export default __webpack_public_path__ + "static/media/3-aumento.a3762803.svg";